import { Image } from "@/components/Elements";
import { ExternalLogin } from "../../types";
import useExternalLogin from "../../hooks/useExternalLogin";

const externalLinks = Object.getOwnPropertyNames(ExternalLogin).filter((prop) =>
  isNaN(parseInt(prop))
);

export const ExternalLoginButton = () => {
  const { handleExternalLogin } = useExternalLogin();

  return (
    <div className="flex">
      {externalLinks.map((item) => (
        <div
          key={item.toString()}
          onClick={() => handleExternalLogin(item)}
          className="cursor-pointer  ml-[10px]"
        >
          <Image
            src={`${item?.toString()?.toLowerCase()}.png`}
            className="w-[45px] h-[45px]"
          />
        </div>
      ))}
    </div>
  );
};
